import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { UserModule } from '../../user/user/user.module';
import { DossierHeaderModule } from '../components/dossierHeader.module';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { planningComponent } from './planning.component';
import { TableModule } from 'primeng-lts/table';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { CalendarModule } from 'primeng-lts/calendar';
import { ChartModule } from 'primeng-lts/chart';
import { DialogModule } from 'primeng-lts/dialog';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { TreeTableModule } from 'primeng-lts/treetable';
import { InplaceModule } from 'primeng-lts/inplace';

@NgModule({
  declarations: [planningComponent],
  imports: [
    CommonModule,
    FormsModule,

    InplaceModule,
    SelectButtonModule,
    CalendarModule,
    DossierHeaderModule,
    WaitLoadingModule,
    TableModule,
    DynamicDialogModule,
    TreeTableModule,
    RouterModule,
    UserModule,
    PanelModule,
    TranslateModule,
    ChartModule,
    DialogModule,
    FormPlycaModule,
    ScrollPanelModule
  ],
  exports: [planningComponent]
})
export class PlanningModule { }
